import { render, staticRenderFns } from "./SharedMediaFilter.vue?vue&type=template&id=24130f68&"
import script from "./SharedMediaFilter.vue?vue&type=script&lang=js&"
export * from "./SharedMediaFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports